"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.retrieveLanguageCode = retrieveLanguageCode;
var _string = require("../../string");
var _url = require("../../url");
var _constants = require("../constants");
var _getDocumentLocale = require("./get-document-locale");
/**
 * Retrieves the language code from the URL parameter or the document's locale data attribute.
 *
 * @returns {string} - The encoded language code or an empty string if not found.
 */
function retrieveLanguageCode() {
  const rawLang = (0, _url.getParameterByName)('lang') || (0, _getDocumentLocale.getDocumentLocale)();
  return typeof rawLang === 'string' ? (0, _string.htmlEntities)(rawLang) : _constants.defaultLanguage;
}